import React from 'react';
import { cn } from "@/lib/utils";
import { X } from 'lucide-react';

const Input = React.forwardRef(({ className, type, value, onClear, ...props }, ref) => {
  const showClearButton = onClear && value;

  return (
    <div className="relative w-full">
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          showClearButton && "pr-10",
          className
        )}
        ref={ref}
        value={value}
        {...props}
      />
      {showClearButton && (
        <button
          type="button"
          onClick={onClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700 transition-colors"
          aria-label="Clear input"
        >
          <X className="h-5 w-5" />
        </button>
      )}
    </div>
  );
});
Input.displayName = "Input";

export { Input };